import React, { useContext, useState } from 'react';
import { Check, Info, ImageOff } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '../../ui/dialog';
import { imgSrc, TemaTienda } from './tiendaUtils';

export const ImagenOpcion = ({ url, alt, className = '' }) => (
  url
    ? <img src={imgSrc(url)} alt={alt} className={`h-full w-full object-contain ${className}`} loading="lazy" />
    : <div className="flex h-full w-full items-center justify-center"><ImageOff className="h-8 w-8 text-zinc-400" /></div>
);

const DialogoEspecificaciones = ({ opcion, abierto, onCerrar, elegida, onElegir }) => {
  const claro = useContext(TemaTienda);
  return (
  <Dialog open={abierto} onOpenChange={v => !v && onCerrar()}>
    <DialogContent className={`max-h-[90vh] overflow-y-auto sm:max-w-md ${claro ? 'tienda-claro border-gray-200 bg-white text-gray-900' : 'border-[#27272A] bg-[#18181B] text-white'}`} data-testid="opcion-especificaciones">
      <div className="aspect-square w-full overflow-hidden rounded-xl bg-zinc-100 p-3">
        <ImagenOpcion url={opcion.imagen_url} alt={opcion.titulo} />
      </div>
      <DialogTitle className="font-serif text-lg">{opcion.titulo}</DialogTitle>
      <DialogDescription className="whitespace-pre-line text-sm leading-relaxed text-zinc-300">
        {opcion.especificaciones || 'Sin especificaciones adicionales.'}
      </DialogDescription>
      <button onClick={() => { onElegir(); onCerrar(); }} className="w-full rounded-xl bg-[#C9A962] py-3 font-semibold text-black transition-colors hover:bg-[#D4B872]" data-testid="opcion-especificaciones-elegir">
        {elegida ? 'Seguir con esta opción' : 'Elegir esta opción'}
      </button>
    </DialogContent>
  </Dialog>
  );
};

export default function TarjetaOpcion({ opcion, elegida, onElegir }) {
  const [verDetalle, setVerDetalle] = useState(false);
  return (
    <div className={`relative overflow-hidden rounded-2xl border-2 bg-[#18181B] transition-[border-color,transform] ${elegida ? 'border-[#C9A962] shadow-lg shadow-[#C9A962]/10' : 'border-[#27272A] hover:border-zinc-600'}`} data-testid={`opcion-${opcion.id}`}>
      <button type="button" onClick={onElegir} className="block w-full text-left active:scale-[0.99]" aria-pressed={elegida} data-testid={`opcion-elegir-${opcion.id}`}>
        <div className="aspect-square bg-zinc-100 p-3"><ImagenOpcion url={opcion.imagen_url} alt={opcion.titulo} /></div>
        <p className={`px-3 pb-1 pt-3 text-sm font-medium ${elegida ? 'text-[#C9A962]' : 'text-white'}`}>{opcion.titulo}</p>
      </button>
      {elegida && <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-[#C9A962] text-black"><Check className="h-4 w-4" /></span>}
      <button type="button" onClick={() => setVerDetalle(true)} className="flex items-center gap-1 px-3 pb-3 text-xs text-zinc-400 transition-colors hover:text-[#C9A962]" data-testid={`opcion-detalle-${opcion.id}`}>
        <Info className="h-3.5 w-3.5" />{opcion.especificaciones ? 'Ver especificaciones' : 'Ver imagen'}
      </button>
      <DialogoEspecificaciones opcion={opcion} abierto={verDetalle} onCerrar={() => setVerDetalle(false)} elegida={elegida} onElegir={() => !elegida && onElegir()} />
    </div>
  );
}
